import { compose, withProps } from 'recompose';

import { product as productUrl } from 'ggApp/utils/urlBuilder/frontshop';

import Card from './Card';

const enhance = compose(
    withProps(({ product }) => ({
        linkTo: productUrl(product.slug),
        name: product.frontname,
        features: product.core_attribute,
        imageUrl: product.image_url,
    })),
);
export default enhance(Card);
